<template>
  <v-img
    class="bet-field"
    :src="require(`@/assets/img/games/wheel/field${field}.jpg`)"
    :data-field="field"
    aspect-ratio="1" width="100%"
  >
    <slot />
    <div class="pay-label font-weight-extrabold text-uppercase mt-2">
      Pays x{{ +field + 1 }}
    </div>
  </v-img>
</template>

<script>

export default {
  props: {
    field: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
  .pay-label {
    position: absolute;
    z-index: 0;
    bottom: 12%;
    left: 0;
    width: 100%;
    color: black;
    font-size: 10px;
    text-align: center;
    pointer-events: none;
  }
</style>
